import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { MainHead } from '../../routes/components/tv/components/common';
import { programMenuList } from '@/network/apis/apiUri';

import PhotoList from './list';
import PhotoModal from './modal';

export default function ProgramPhotoGallery({ mode, setSubLocation, history }) {
  const location = useLocation();

  const search = new URLSearchParams(location.search);
  const photoId = search.get('photoId') ?? null;

  const [title, setTitle] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const searchParams = new URLSearchParams(history.location.search);

    const formData = new FormData(e.currentTarget);

    const searchOpt = formData.get('searchOpt');
    const searchText = formData.get('searchText') ?? '';

    searchParams.set('searchOpt', searchOpt);
    if (searchText) searchParams.set('searchText', searchText);
    else {
      searchParams.delete('searchOpt');
      searchParams.delete('searchText');
    }
    searchParams.delete('page');

    history.push(`?${searchParams.toString()}`);
  };

  useEffect(() => {
    if (setSubLocation) {
      setSubLocation(history.location.pathname);
    }
    programMenuList({
      program_id: history.location.pathname.split('/')[2],
      lan_code: mode,
    }).then((res) => {
      if (res.status === 200) {
        const board = res.data.item.find((el) => el.type.includes('program_photo'));
        setTitle(board.title ?? '');
      }
    });
  }, []);

  return (
    <div className="photo-gallery">
      <MainHead title={title} mode={mode} handleSubmit={handleSubmit} />
      <PhotoList title={title} />
      {photoId && <PhotoModal />}
    </div>
  );
}
